import { useContext } from "react";
import {
  WhatsappAccountContext,
  WhatsappAccountContextType,
} from "./WhatsappAccountContext";

export const useWhatsappAccount = (): WhatsappAccountContextType => {
  const context = useContext(WhatsappAccountContext);

  if (context === undefined) {
    throw new Error(
      "useWhatsappAccount must be used within a WhatsappAccountProvider"
    );
  }

  return context;
};
